import { render, staticRenderFns } from "./ProfileKeywordSettingTable.vue?vue&type=template&id=3d098545&scoped=true"
import script from "./ProfileKeywordSettingTable.vue?vue&type=script&lang=ts"
export * from "./ProfileKeywordSettingTable.vue?vue&type=script&lang=ts"
import style0 from "./ProfileKeywordSettingTable.vue?vue&type=style&index=0&id=3d098545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d098545",
  null
  
)

export default component.exports